<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="tariffPlans"
      :items="tariffPlans"
      :fields="tariffPlansFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>

    <FormTariffPlans
      :ipPoolsList="ipPoolsList"
      :timeRangeList="timeRangeList"
      :schemeList="schemeList"
      :policyList="policyList"
      :suppliertList="suppliertList"
      :contractList="contractList"
      :groupList="groupList"
      :isEdit="isEdit"
      :currentRowTariffPlans="selectedTarrifPlans"/>
  </div>
</template>

<script>
import FormTariffPlans from '../formTariffPlans'
export default {
  components: {
    FormTariffPlans
  },
  data () {
    return {
      tariffPlansFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'create_date', label: this.$i18n.t('Created on'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'whoCreate', label: this.$i18n.t('Created by'), sortable: true},
        {key: 'change_date', label: this.$i18n.t('Modified on'), sortable: true, formatter: (val, key, item) => { return val ? this.$root.showDataWithTZDelta(val) : this.$i18n.t('Not installed') }},
        {key: 'whoChange', label: this.$i18n.t('Modified by'), sortable: true},
        {key: 'balanceRollover', label: this.$i18n.t('Zero balance at the accounting period end'), sortable: true},
        {key: 'comments', label: this.$i18n.t('Comment'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      isEdit: false,
      selectedTarrifPlans: {
        name: ''
      },
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.isEdit = false
      this.selectedTarrifPlans = {
        name: '',
        comments: '',
        balance_rollover: 0
      }
      this.$root.$emit('bv::show::modal', 'modalTariffPlans', '#btnShow')
    },
    editItem (item) {
      this.isEdit = true
      this.selectedTarrifPlans = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalTariffPlans', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Tariff plans"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Tariffing/DELETE_TARIFFS', item.id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_TARIFFS')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    timeRangeList () {
      let tmp = []
      for (let el of this.$store.getters['Tariffing/TIME_RANGE']) {
        let newEl = {
          value: el.tr_id,
          text: el.name + ' (' + el.tr_id + ')'
        }
        tmp.push(newEl)
      }
      return tmp
    },
    ipPoolsList () {
      let tmp = []
      for (let el of this.$store.getters['Settings/IP_POOLS']) {
        let newEl = {
          value: el.id,
          text: el.name
        }
        tmp.push(newEl)
      }
      return tmp
    },
    schemeList () {
      let tmp = [
        {value: 0, text: '---'}
      ]
      for (let el of this.$store.getters['Tariffing/COEFFICIENT_SCHEME']) {
        let newEl = {
          value: el.id,
          text: el.name
        }
        tmp.push(newEl)
      }
      return tmp
    },
    policyList () {
      let tmp = []
      for (let el of this.$store.getters['Tariffing/CHARGE_POLICIES']) {
        let newEl = {
          value: el.policy_id,
          text: el.name + ' (' + el.policy_id + ')'
        }
        tmp.push(newEl)
      }
      return tmp
    },
    suppliertList () {
      let tmp = [
        {value: 0, text: ''}
      ]
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Settings/COMPANIES']))
      for (let el of copy) {
        let newEl = {
          value: el.id,
          text: el.name
        }
        tmp.push(newEl)
      }
      return tmp
    },
    groupList () {
      let tmp = [
        {value: 0, text: this.$i18n.t('Don`t delete')}
      ]
      for (let el of this.$store.getters['Users/GROUPS']) {
        let newEl = {
          value: el.group_id,
          text: el.group_name + ' (' + el.group_id + ')'
        }
        tmp.push(newEl)
      }
      return tmp
    },
    contractList () {
      let tmp = [
        {value: 0, text: ''}
      ]
      for (let el of this.$store.getters['Tariffing/CONTRACT_TYPE']) {
        let newEl = {
          value: el.id,
          text: el.name
        }
        tmp.push(newEl)
      }
      return tmp
    },
    tariffPlans () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TARIFFS']))
      for (let el of copy) {
        for (let elSysUsers of JSON.parse(JSON.stringify(this.$store.getters['Users/SYSTEM_USERS_SHORT_DATA']))) {
          if (elSysUsers.user_id === el.who_create) {
            el.whoCreate = elSysUsers.login + ' (' + elSysUsers.user_id + ')'
          }
          if (elSysUsers.user_id === el.who_change) {
            el.whoChange = elSysUsers.login + ' (' + elSysUsers.user_id + ')'
          }
        }
        if (el.balance_rollover === 1) {
          el.balanceRollover = true
        } else {
          el.balanceRollover = false
        }
      }
      return copy
    }
  },
  mounted () {
    this.$store.dispatch('Tariffing/GET_TARIFFS')
    this.$store.dispatch('Users/GET_SYSTEM_USERS_SHORT_DATA')
    this.$store.dispatch('Users/GET_GROUPS')
    this.$store.dispatch('Tariffing/GET_CONTRACT_TYPE')
    this.$store.dispatch('Settings/GET_COMPANIES')
    this.$store.dispatch('Tariffing/GET_SERVICES')
    this.$store.dispatch('Tariffing/GET_CHARGE_POLICIES')
    this.$store.dispatch('Tariffing/GET_COEFFICIENT_SCHEME')
    this.$store.dispatch('Tariffing/GET_MEDIA_GROUPS')
    this.$store.dispatch('Tariffing/GET_MEDIA_CONTENTS')
    this.$store.dispatch('Settings/GET_IP_POOLS')
    this.$store.dispatch('Tariffing/GET_TIME_RANGE')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/servicesAndTariffs/tariffPlans/main.vue